import { ReactNode } from 'react'

import { Text } from '@/components/base/text'
import { clx } from '@/utils/clx'

export type SectionRowProps = {
	title: string
	value?: ReactNode | string | null
	actions?: ReactNode
}

export const SectionRow = ({ title, value, actions }: SectionRowProps) => {
	const isValueString = typeof value === 'string' || !value

	return (
		<div
			className={clx(`grid w-full grid-cols-2 items-center gap-4 px-6 py-4 text-ui-fg-subtle`, {
				'grid-cols-[1fr_1fr_28px]': !!actions
			})}
		>
			<Text size='small' weight='plus' leading='compact'>
				{title}
			</Text>

			{isValueString ? (
				<Text size='small' leading='compact' className='whitespace-pre-line text-pretty'>
					{value ?? '-'}
				</Text>
			) : (
				<div className='flex flex-wrap gap-1'>{value}</div>
			)}

			{actions && <div>{actions}</div>}
		</div>
	)
}
